import { basic_offside_scanner } from './basic_offside.jsy'
import { bind_context_scanner } from './basic_contexts.jsy'

export function scan_offside_contexts(source, feedback, disp_name, context_scanners) ::
  // see scan_javascript and scan_clike for good context_scanners
  const context_scanner = bind_context_scanner(disp_name, context_scanners)
  return context_scanner @ basic_offside_scanner(source, feedback)

